import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Agenda from './pages/Agenda';
import Speakers from './pages/Speakers';
import Questions from './pages/Questions';
import Streaming from './pages/Streaming';
import Configs from './pages/Configs';
import AdminPollResults from './pages/AdminPollResults';
import Surveys from './pages/Surveys';
import SurveyStats from './pages/SurveyStats';
import Trivia from './pages/Trivia';
import PageBuilder from './pages/PageBuilder';
import Salas from './pages/Salas';
import Reports from './pages/Reports';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return (
        <div className="h-screen w-full flex flex-col items-center justify-center bg-slate-900 text-white">
            <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-6"></div>
            <span className="font-black text-xs uppercase tracking-[0.3em] opacity-40"> Loading</span>
        </div>
    );
    if (!user) return <Navigate to="/login" />;
    return <AdminLayout>{children}</AdminLayout>;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    {/* Protected Routes */}
                    <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                    <Route path="/agenda" element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
                    <Route path="/speakers" element={<ProtectedRoute><Speakers /></ProtectedRoute>} />
                    <Route path="/questions" element={<ProtectedRoute><Questions /></ProtectedRoute>} />
                    <Route path="/streaming" element={<ProtectedRoute><Streaming /></ProtectedRoute>} />
                    <Route path="/configs" element={<ProtectedRoute><Configs /></ProtectedRoute>} />
                    <Route path="/surveys" element={<ProtectedRoute><Surveys /></ProtectedRoute>} />
                    <Route path="/survey-stats" element={<ProtectedRoute><SurveyStats /></ProtectedRoute>} />
                    <Route path="/trivia" element={<ProtectedRoute><Trivia /></ProtectedRoute>} />
                    <Route path="/resultados" element={<ProtectedRoute><AdminPollResults /></ProtectedRoute>} />
                    <Route path="/pages-builder" element={<ProtectedRoute><PageBuilder /></ProtectedRoute>} />
                    <Route path="/salas" element={<ProtectedRoute><Salas /></ProtectedRoute>} />
                    <Route path="/reportes" element={<ProtectedRoute><Reports /></ProtectedRoute>} />

                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
